export default __webpack_public_path__ + "static/media/blog-img-1.c2723959.png";